import React, { Component } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { Label } from '@dbk/ui-forms';
import Text from '@dbk/ui-text';
import Dropdown from '@dbk/ui-dropdowns';
import Button from '@dbk/ui-buttons';
import { isEmpty } from 'lodash';
// import '../../../../src/assets/styles/hrmw-mcd.scss'; // commented due to color contrast tool checker issue

class FilterModal extends Component {
	constructor(props) {
		super(props);
		this.state = ({
			isEmailFilterSelected: false,
			isPhoneFilterSelected: false,
			isFaxFilterSelected: false,
			personIdSelected: '',
			filterCount: 0
		});

	}

	componentWillMount() {
		if(!isEmpty(this.props.hrmw.appliedFilters)) {
			if(this.props.hrmw.appliedFilters.isEmailFilterSelected) {
				this.setState({ isEmailFilterSelected: true });
			}

			if(this.props.hrmw.appliedFilters.isFaxFilterSelected) {
				this.setState({ isFaxFilterSelected: true });
			}

			if(this.props.hrmw.appliedFilters.isPhoneFilterSelected) {
				this.setState({ isPhoneFilterSelected: true });
			}

			if(this.props.hrmw.appliedFilters.personIdSelected) {
				this.setState({ personIdSelected: this.props.hrmw.appliedFilters.personIdSelected });
			}
			this.setState({ filterCount: this.props.hrmw.filterCount });
		}
	}

	selectPerson = (person) => {
		this.setState({ personIdSelected: person }, () => {
			this.getFilterCount();
		});
	}

	emailFilterClicked = () => {
		this.setState({ isEmailFilterSelected: !this.state.isEmailFilterSelected }, () => {
			this.getFilterCount();
			// this.props.setFilterCount({this.state.filterCount});
		});
	}

	faxFilterClicked = () => {
		this.setState({ isFaxFilterSelected: !this.state.isFaxFilterSelected }, () => {
			this.getFilterCount();
		});
	}

	phoneFilterClicked = () => {
		this.setState({ isPhoneFilterSelected: !this.state.isPhoneFilterSelected }, () => {
			this.getFilterCount();
		});
	}

	clearFilter = async () => {
		await this.props.hrmw.saveFilters({
			isEmailFilterSelected: false,
			isFaxFilterSelected: false,
			isPhoneFilterSelected: false,
			personIdSelected: false,
			filterCount: 0
		});

		this.setState({
			isEmailFilterSelected: false,
			isPhoneFilterSelected: false,
			isFaxFilterSelected: false,
			personIdSelected: '',
		}, () => {
			this.getFilterCount();
		});
	}

	applyFilter = async () => {

		const {isEmailFilterSelected, isFaxFilterSelected, isPhoneFilterSelected, personIdSelected, filterCount } = this.state;

		await this.props.hrmw.saveFilters({
			isEmailFilterSelected: isEmailFilterSelected,
			isFaxFilterSelected: isFaxFilterSelected,
			isPhoneFilterSelected: isPhoneFilterSelected,
			personIdSelected: personIdSelected,
			filterCount: filterCount
		});
		await this.getFilterCount();
		await this.props.closeFilterModal();
	}

	getFilterCount = async () => {

		const {isEmailFilterSelected, isFaxFilterSelected, isPhoneFilterSelected, personIdSelected } = this.state;
		let count = 0;

		if(isEmailFilterSelected) {
			count +=1;
		}
		if(isFaxFilterSelected) {
			count +=1;
		}
		if(isPhoneFilterSelected) {
			count +=1;
		}
		if(personIdSelected) {
			count +=1;
		}

		this.setState({filterCount: count});


		await this.props.hrmw.saveFilters({
			isEmailFilterSelected: isEmailFilterSelected,
			isFaxFilterSelected: isFaxFilterSelected,
			isPhoneFilterSelected: isPhoneFilterSelected,
			personIdSelected: personIdSelected,
			filterCount: count
		});

		this.props.setFilterCount(count);
		
	}

	render() {
		const { i18n: { messages }, hrmw: { contactDetailsPersonData } } = this.props;
		const { isEmailFilterSelected, isPhoneFilterSelected, isFaxFilterSelected, personIdSelected } = this.state;

		let personDropdownValues = [];

		_.forEach(contactDetailsPersonData, function(value) {
			let label;
			if(value.name) {
				label = value.name;
			} else {
				label = `${value.firstName} ${value.middleName} ${value.lastName}`;
			}
			personDropdownValues.push({
				value: value.personId,
				label: label
			});
		});

		return (
			<div className="small-12 medium-12 large-12">
				<div className="pad-bottom-5">
					<div className="column" tabIndex={0}>
						<Text secondary>{messages['app.manageContactDetails.type']}</Text>
					</div>
				</div>
				<div className="pad-bottom-5 headerMargin">
					<div className="column small-4 medium-4 large-4">
						<Button size="large" tertiary={!isEmailFilterSelected} onClick={this.emailFilterClicked} className={"filterButton full-width " + (isEmailFilterSelected ? 'btn-primary' : '')}>{messages['app.manageContactDetails.filter.email']}</Button>
					</div>
					<div className="column small-4 medium-4 large-4">
						<Button size="large" tertiary={!isPhoneFilterSelected} onClick={this.phoneFilterClicked} className={"filterButton full-width " + (isPhoneFilterSelected ? 'btn-primary' : '')}>{messages['app.manageContactDetails.filter.phone']}</Button>
					</div>
					<div className="column small-4 medium-4 large-4">
						<Button size="large" tertiary={!isFaxFilterSelected} onClick={this.faxFilterClicked} className={"filterButton full-width " + (isFaxFilterSelected ? 'btn-primary' : '')}>{messages['app.manageContactDetails.addContact.fax']}</Button>
					</div>
				</div>
				<div className="pad-bottom-5 headerMargin">
					<div className="column" tabIndex={0}>
						<Label>{messages['app.manageContactDetails.person']}</Label>
					</div>
				</div>
				<div className="row">
					<div className="column">
						<Dropdown
							textID="person_name"
							testID='dropdown-person-list-test'
							defaultLabel={messages['app.manageContactDetails.addContact.namePlaceholder']}
							className="large-12 medium-12 small-12 full-width dropdownColor"
							size='large'
							fullWidth
							selected={personIdSelected}
							onChange={this.selectPerson}
							options={personDropdownValues}
						/>
					</div>
				</div>
				<div className="row addContactBtnGroup	">
					<div className="column medium-6 small-6 large-6 rightTextAligned">
						<Button size="large" tertiary onClick={this.clearFilter}>{messages['app.manageContactDetails.clear.button']}</Button>
					</div>
					<div className="column medium-6 small-6 large-6 leftTextAligned">
						<Button size="large" onClick={this.applyFilter}>{messages['app.manageContactDetails.apply.button']}</Button>
					</div>
				</div>
			</div>
		)
	}
}

export default createContainer({
	$queries: {
		i18n: {
			messages: true,
		},
		hrmw: {
			saveFilters: {$call: 'saveFilters'},
			appliedFilters: true,
			filterCount: true,
			contactDetailsPersonData: true,
		}
	},
})(FilterModal);